/**
 * Loading state for Plan Guide pages.
 *
 * Phase 5: Enhanced with accessibility and responsive styling.
 *
 * @see frontend/workspace/CU-868gzzjua/frontend_implementation_guide.md
 */

import React from 'react';
import { Box, Skeleton, Typography, CircularProgress } from '@mui/material';

interface Props {
  message?: string;
}

export const PlanGuideLoading: React.FC<Props> = ({
  message = 'Loading...',
}) => {
  return (
    <Box
      role="status"
      aria-live="polite"
      aria-label={message}
      sx={{
        p: { xs: 2, sm: 3 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {/* Spinner for immediate feedback */}
      <CircularProgress
        size={40}
        sx={{ mb: 2 }}
        aria-hidden="true"
      />

      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          mb: 3,
          textAlign: 'center',
        }}
      >
        {message}
      </Typography>

      {/* Skeleton placeholder - responsive width */}
      <Box sx={{ width: '100%', maxWidth: 600 }}>
        {/* Skeleton for card */}
        <Skeleton
          variant="rounded"
          height={120}
          sx={{ mb: 2 }}
          aria-hidden="true"
        />

        {/* Skeleton for action buttons - responsive flex */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 2,
          }}
        >
          <Skeleton
            variant="rounded"
            sx={{
              width: { xs: '100%', sm: 120 },
              height: { xs: 48, sm: 40 },
            }}
            aria-hidden="true"
          />
          <Skeleton
            variant="rounded"
            sx={{
              width: { xs: '100%', sm: 120 },
              height: { xs: 48, sm: 40 },
            }}
            aria-hidden="true"
          />
        </Box>
      </Box>
    </Box>
  );
};
